// extracted by mini-css-extract-plugin
module.exports = {"container":"StatusElement_container__3KdtK","fail":"StatusElement_fail__duxK-","transparent":"StatusElement_transparent__36izK","popover":"StatusElement_popover__TmQ4g"};